import WeekHelper from '../../../functions/WeekHelper';
import moment from 'moment';
import { translateOptionValue } from '../../exl/shared/translations';

const searchParams = new URLSearchParams(window.location.search);

export const EstablishColumnBands = (startWeek, endWeek) => {
    var innerColumnBands = [];

    startWeek = WeekHelper.GetWeek(startWeek);
    endWeek = WeekHelper.GetWeek(endWeek);

    var weeks = WeekHelper.GetWeeksBetween(startWeek, endWeek);
    var yearSplitWeeks = WeekHelper.YearSplitWeeks(weeks);

    yearSplitWeeks.map((element) => {
        let startYear = element[0].substring(0, 4);
        innerColumnBands.push({ title: startYear, children: [] });
        element.map((value) => {
            innerColumnBands[innerColumnBands.length - 1].children.push({ columnName: value });
            return null;
        });
        return null;
    });

    return innerColumnBands;
};

export const FormatColumnsCovering = (data, TableColumnExtensions, weekWidth) => {
    const columns = data.map((col) => ({ title: 'v' + col.toString().slice(4), name: col.toString() }));

    data.forEach((col) => {
        var checkString = col.toString();
        var resultList = TableColumnExtensions.filter((element) => {
            return element.columnName === checkString;
        });
        const check = resultList.length > 0;

        if (!check) {
            TableColumnExtensions.push({ columnName: checkString, width: weekWidth, align: 'left' });
        }
    });

    return columns;
};

export const IsWeekSpanLessThanOccupancyCheck = (selectedOccupancy, startWeek, endWeek, dispatch) => {
    if (selectedOccupancy === 'availableNextFiveWeeks') {
        let startYearWeek = WeekHelper.GetWeek(startWeek);
        let endYearWeek = WeekHelper.GetWeek(endWeek);
        let weeks = WeekHelper.GetWeeksBetween(startYearWeek, endYearWeek);
        if (weeks.length < 5) {
            let newEndYearWeek = WeekHelper.AddWeeks(weeks[0], 4);
            let newEndWeekMonday = WeekHelper.GetMondayDateOfWeek(newEndYearWeek);
            dispatch({ type: 'WEEK_UPDATE', startWeek: startWeek, endWeek: newEndWeekMonday });
            return true;
        }
    }
    return false;
};

export const getValueFromUrl = (key) => {
    if (window.location.search && searchParams.get(key)) {
        return searchParams.get(key);
    }
}

export const parseValueFromUrl = (value) => {

    try {
        return JSON.parse(value);
    }
    catch {
        return [];
    }
}
export const createDateFromWeekNumber = (value) => {
    if (getValueFromUrl(value)) {
        const urlDate = getValueFromUrl(value);
        if (urlDate !== null) {
            const date = new moment(urlDate, 'YYYYWW').toDate();
            return date;
        }
    }
}

export const getLabelAndValueFromUrl = (key, options) => {
    if (window.location.search && searchParams.get(key)) {
        const value = searchParams.get(key);
        return { label: translateOptionValue(value, options), value: value }
    }
}
export const getLabelsAndValuesFromFilterType = (filterType, options) => {
    const filterColumn = getSingleFilterColumn(filterType);
    const filterValues = splitFilterValue(filterColumn);
    if (filterValues !== null && filterValues !== undefined) {
        let optionValues = [];
        // eslint-disable-next-line array-callback-return
        filterValues.map(v => {
            optionValues.push({ label: translateOptionValue(v, options), value: v })
        })
        return optionValues;
    }
}

export const convertFiltersToString = (filterType) => {
    if (window.location.search && searchParams.get(filterType)) {
        const filters = searchParams.get(filterType);
        if (filters !== null && filters !== '') {
            const parsedFilters = JSON.parse(filters);
            return parsedFilters;
        }
    }
}

export const getFilterValue = (filters, columnName) => {
    if (filters !== null && filters !== '') {

        const filter = filters.find((f) => f.columnName === columnName);
        return filter ? filter.value.split('"').join('') : '';
    }
};
export const splitFilterValue = (value) => {
    if (value !== null && value !== '') {
        return value.split('OR');
    }
}

export const getSingleFilterColumn = (columnName) => {
    const value = getValueFromUrl('filters');
    const parsedValue = parseValueFromUrl(value, columnName)
    return getFilterValue(parsedValue, columnName);
}